import React from 'react'
import { BsArrowLeftCircle } from 'react-icons/bs'
import './SliderCommentItem.css'
import { Row, Col } from 'react-bootstrap'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import userDefault from '../../Assets/images/userDefault.jpg'
export default function SliderCommentItem({ item }) {
    return (
        <Row className='slider-comment-item'>
            <div className='line-border'>

            </div>
            <Col xs={6} className='comment-item-right'>
                {
                    
                    item.comment.registererUser.profileImage != null ? (
                        <img src={axiosConfig.defaults.baseURL + "Images/UserImage/" + item.comment.registererId + "/" + item.comment.registererUser.profileImage} alt={`تصویر ${item.comment.registererUser.userName}}`} />
                    ) : (
                        <img src={userDefault} alt={`تصویر ${item.comment.registererUser.userName}}`} />
                    )
                }
                <h2 className='comment-item-userName'>{item.comment.registererUser.userName}</h2>
            </Col>
            <Col xs={6} className='comment-item-left'>
                <p>
                    {
                        item.comment.text
                    }
                </p>
                <BsArrowLeftCircle />
            </Col>

        </Row>
    )
}
